import React from 'react';
import { clientLogos } from '../data/content';
import { Reveal } from './Reveal';
export function LogoCloud() {
  const marquee = [...clientLogos, ...clientLogos];
  return <section aria-label="Empresas que confían en Almaria" className="border-y border-slate-200/80 bg-white py-14" data-id="element-83" data-mp="1gntlzik5u9ib">
      <Reveal className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-84" data-mp="1cmrmd0mbzvft">
        <p className="text-center text-[13px] font-medium uppercase tracking-[0.16em] text-slate-500" data-id="element-85" data-mp="1cob3sujq4cj6">
          Empresas que confían en soluciones digitales modernas
        </p>
      </Reveal>

      <div className="relative mt-10 overflow-hidden" data-id="element-86" data-mp="12v415hgdbams">
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" data-id="element-87" data-mp="xwketfxv3wtw" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" data-id="element-88" data-mp="owns3jv1981h" />
        <ul className="almaria-marquee flex w-max items-center gap-14 px-6" data-id="element-89" data-mp="jznodflnohdj">
          {marquee.map((logo, i) => <li key={`${logo}-${i}`} aria-hidden={i >= clientLogos.length} className="text-xl font-semibold tracking-[-0.02em] text-slate-400 grayscale transition-colors duration-300 hover:text-ink-soft" data-id="element-90" data-mp="21zsppxg54wpv" data-mpi={i}>
              {logo}
            </li>)}
        </ul>
      </div>
    </section>;
}